<script lang="ts" setup>
import { cn } from '@/utils';
import type { BreadcrumbListProps } from '.';

const props = defineProps<BreadcrumbListProps>();
</script>

<template>
	<ol :class="cn('flex flex-wrap items-center gap-3 break-words', props.class)">
		<slot />
	</ol>
</template>
